export default {
  FETCH_DATA: 'billcont_fetch_data',
  UPDATE_QUERY: 'billcont_update_query',
  LOAD_MORE_DATA: 'billcont_load_more_data',
  UPDATE_LOADING: 'billcont_update_loading',
  UPDATE_SELECTED: 'billcont_update_selected',
};
